type WithChildren = {
  children: React.ReactNode;
};

export const TextContainer: React.FC<WithChildren> = ({ children }) => {
  return (
    <div
      className={`
      tw-mx-2
      tw-max-w-[386px]
      [&>h2]:desktop:!tw-lf-title-lg
      [&>h3]:!tw-lf-body-regular-md
      [&>p]:!tw-lf-body-regular-sm
      desktop:tw-mx-0
      [&>h2]:tw-text-center
      [&>h2]:tw-text-lg
      [&>h2]:!tw-leading-[130%]
      [&>h2]:desktop:tw-mb-3
      [&>h2]:desktop:tw-text-left
      [&>h2]:desktop:!tw-text-[32px]
      [&>h2]:desktop:!tw-leading-[150%]
      [&>h3]:tw-text-center
      [&>h3]:desktop:tw-text-left
      [&>p]:tw-text-base
      `}
    >
      {children}
    </div>
  );
};

export const Title: React.FC<WithChildren> = ({ children }) => {
  return <h2>{children}</h2>;
};

export const Text: React.FC<WithChildren> = ({ children }) => {
  return <p className="!tw-text-center desktop:!tw-text-left">{children}</p>;
};

export const ChoicesContainer: React.FC<WithChildren> = ({ children }) => {
  return (
    <div className="tw-grid tw-w-full tw-max-w-[520px] tw-grid-cols-1 tw-flex-wrap tw-gap-3 phone-s:tw-grid-cols-2 desktop:tw-max-w-[486px] [&_label]:tw-flex-grow [&_label]:tw-basis-0">
      {children}
    </div>
  );
};

export const MultipleChoicesLayout: React.FC<WithChildren> = ({ children }) => {
  return (
    <div className="limited-width-container tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-py-3 tw-align-top desktop:tw-flex-row desktop:tw-items-start desktop:tw-gap-8 desktop:tw-py-8">
      {children}
    </div>
  );
};
